import React from 'react';
import Box from '@mui/material/Box';
import { Spinner, StackableCardDeck } from '@uplift/ui-v2';
import { ProviderCard } from '../../../components';
import { UserMatchOverview } from '@uplift/queries';
import { MissingProviderPrompt } from './missing-provider-prompt.component';
import { useL10n } from '@uplift/hooks';
import { ROUTING_CONFIG, findPsychiatryRoute } from '@uplift/constants';
import { PsychAppointmentBookingSource } from '@uplift/api';


type ProviderSidebarProps = {
  matches: UserMatchOverview[];
  isLoading: boolean;
  showTherapistPrompt: boolean;
  showPsychiatristPrompt: boolean;
};


export const ProvidersSideBar: React.VFC<ProviderSidebarProps> = ({ matches, isLoading, showTherapistPrompt, showPsychiatristPrompt }) => {
  const l10n = useL10n();

  if (isLoading) {
    return (
      <Box my={5}>
        <Spinner />
      </Box>
    );
  }

  return (
    <StackableCardDeck>
      {showPsychiatristPrompt && (
        <MissingProviderPrompt
          title={l10n.dashboardCareTeam.notMatchedPsychiatrist.title}
          description={l10n.dashboardCareTeam.notMatchedPsychiatrist.description}
          cta={l10n.dashboardCareTeam.notMatchedPsychiatrist.cta}
          to={findPsychiatryRoute.createLink(null, { source: PsychAppointmentBookingSource.clientHomeDashboard })}
        />
      )}
      {showTherapistPrompt && (
        <MissingProviderPrompt
          title={l10n.dashboardCareTeam.notMatchedTherapist.title}
          description={l10n.dashboardCareTeam.notMatchedTherapist.description}
          cta={l10n.dashboardCareTeam.notMatchedTherapist.cta}
          to={ROUTING_CONFIG.matching}
          outlined
        />
      )}
      {matches?.map((match, i) => (
        <ProviderCard
          key={match.match.id || i}
          matchId={match.match.id}
          provider={match.provider}
          square
        />
      ))}
    </StackableCardDeck>
  );
};
